<template>
  <!-- 客诉管理表 -->
  <div class="mainClient">
    <div style="margin-top: 15px;margin-left: 30px;">
      <el-select
          class="bigSize"
          v-model="searchBar.sourceOfComplaint"
          clearable
          placeholder="请选择问题来源"
          filterable
      >
        <el-option label="账号邮件" value="1"></el-option>
        <el-option label="客服邮箱" value="2"></el-option>
        <el-option label="FB" value="3"></el-option>
        <el-option label="退款订单" value="4"></el-option>
        <el-option label="重发订单" value="5"></el-option>
        <el-option label="差评" value="6"></el-option>
        <el-option label="客户联系方式" value="7"></el-option>
      </el-select>
      <el-select
          class="bigSize"
          v-model="searchBar.complaintType"
          clearable
          placeholder="请选择问题类型"
          filterable
      >
        <el-option label="质量问题" value="1"></el-option>
        <el-option label="配件问题" value="2"></el-option>
        <el-option label="包装问题" value="3"></el-option>
        <el-option label="物流问题" value="4"></el-option>
        <el-option label="客户误操作" value="5"></el-option>
        <el-option label="客户取消订单" value="6"></el-option>
        <el-option label="客户无反馈" value="7"></el-option>
        <el-option label="亚马逊退货问题" value="8"></el-option>
        <el-option label="其他" value="9"></el-option>
      </el-select>
      <el-select v-model="searchBar.status" clearable placeholder="请选择状态" filterable>
        <el-option label="跟进中" value="1"></el-option>
        <el-option label="已解决" value="2"></el-option>
      </el-select>
      <el-input placeholder="请输入客户联系方式" v-model="searchBar.contactInformation" style="width:180px;"
                clearable></el-input>
      <el-input placeholder="请输入内部SKU" v-model="searchBar.psku" style="width:150px;" clearable></el-input>
      <el-input placeholder="请输入具体问题" v-model="searchBar.detailedProblem" style="width:150px;"
                clearable></el-input>
      <el-input placeholder="请输入跟踪进度" v-model="searchBar.processingProgress" style="width:150px;"
                clearable></el-input>
      <el-input placeholder="请输入订单号" v-model="searchBar.amazonOrderId" style="width:220px;" clearable>
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>

    </div>

    <div class="client">
      <el-table :data="tableData" style="width: 100%">
<!--        <el-table-column label="客诉ID" width="100px">-->
<!--          <template v-slot="scope">-->
<!--            <span style="margin-left: 10px">{{ scope.row.complaintId }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="创建时间" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.complaintTime |datefilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="问题来源" width="130px">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceOfComplaint==1" style="margin-left: 10px">账号邮件</span>
            <span v-if="scope.row.sourceOfComplaint==2" style="margin-left: 10px">客服邮箱</span>
            <span v-if="scope.row.sourceOfComplaint==3" style="margin-left: 10px">FB</span>
            <span v-if="scope.row.sourceOfComplaint==4" style="margin-left: 10px">退款订单</span>
            <span v-if="scope.row.sourceOfComplaint==5" style="margin-left: 10px">重发订单</span>
            <span v-if="scope.row.sourceOfComplaint==6" style="margin-left: 10px">差评</span>
            <span v-if="scope.row.sourceOfComplaint==7" style="margin-left: 10px">客户联系方式</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" width="200px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.amazonOrderId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.clientName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="客户邮箱" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.clientMail }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="客户联系方式" width="160px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.contactInformation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户FB-ID" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.buyerFb }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部SKU" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.psku }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卖家SKU" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.msku }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售账号" width="100px" prop="sellerUser">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sellerUser }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客服邮箱" width="100px" prop="storeMail">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.storeMail }}</span>
          </template>
        </el-table-column>
        <el-table-column label="问题类型" width="130px">
          <template slot-scope="scope">
            <span v-if="scope.row.complaintType==1" style="margin-left: 10px">质量问题</span>
            <span v-if="scope.row.complaintType==2" style="margin-left: 10px">配件问题</span>
            <span v-if="scope.row.complaintType==3" style="margin-left: 10px">包装问题</span>
            <span v-if="scope.row.complaintType==4" style="margin-left: 10px">物流问题</span>
            <span v-if="scope.row.complaintType==5" style="margin-left: 10px">客户误操作</span>
            <span v-if="scope.row.complaintType==6" style="margin-left: 10px">客户取消订单</span>
            <span v-if="scope.row.complaintType==7" style="margin-left: 10px">客户无反馈</span>
            <span v-if="scope.row.complaintType==8" style="margin-left: 10px">亚马逊退货问题</span>
            <span v-if="scope.row.complaintType==9" style="margin-left: 10px">其他</span>
          </template>
        </el-table-column>
        <el-table-column label="购买时间" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.purchaseDate |datefilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="具体问题" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.detailedProblem }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟踪进度" width="210px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.processingProgress }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1" style="margin-left: 10px">跟进中</span>
            <span v-else style="margin-left: 10px">已解决</span>
          </template>
        </el-table-column>
        <el-table-column label="更新人" width="100px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="170px">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.updateTime |datefilter }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="250px">
          <template slot="header">
            <!-- psku -->
            <el-button type="primary" size="mini" @click="AddDialog">新增</el-button>
            <!-- 导入 -->
            <el-upload
                class="upload-demo"
                action="string"
                :limit="1"
                :before-upload="handleBeforeUpload"
                :http-request="husinessLicenseHandler"
                :show-file-list="false"
                ref="upload"
                :file-list="fileList">
              <el-button size="mini" type="success" :loading="uploadLoading">导入</el-button>
            </el-upload>
            <el-button type="warning" size="mini" @click="exportExcel()"  :loading="downloadLoading">导出</el-button>
          </template>
          <template slot-scope="scope">
            <el-button size="mini" type="info"
                       @click="$router.push({path:'/operatingRecord',query:{complaintId:JSON.stringify(scope.row.complaintId)}})">
              操作记录
            </el-button>
            <el-button size="mini" @click="EditList(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.complaintId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <div class="block">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
            layout="sizes,prev, pager, next,jumper"
            :total="total">
        </el-pagination>
      </div>
      <!-- 新增的对话框 -->
      <el-dialog title="客诉管理表" :visible.sync="AddDialogVisible" width="30%" center @close="AddDialogFalse">
        <el-form :label-position="labelPosition" label-width="100px" :model="addForm">
          <el-form-item label="问题来源">
            <el-select v-model="addForm.sourceOfComplaint" placeholder="请选择" clearable>
              <el-option label="账号邮件" value="1"></el-option>
              <el-option label="客服邮箱" value="2"></el-option>
              <el-option label="FB" value="3"></el-option>
              <el-option label="退款订单" value="4"></el-option>
              <el-option label="重发订单" value="5"></el-option>
              <el-option label="差评" value="6"></el-option>
              <el-option label="客户联系方式" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model="addForm.amazonOrderId" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="addForm.clientName" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model="addForm.contactInformation" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户FB-ID">
            <el-input v-model="addForm.buyerFb" clearable></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="addForm.psku" @blur="handleEnter" clearable></el-input>
          </el-form-item>
          <!-- 新增卖家sku字段，数据来源接口 -->
          <el-form-item label="卖家SKU">
            <el-select v-model="addForm.msku" filterable placeholder="请选择" clearable>
              <el-option
                  v-for="(item,index) in optionsMsku"
                  :key="index"
                  :label="item.msku"
                  :value="item.msku">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售账号">
            <el-select v-model="addForm.salesAccount" filterable placeholder="请选择" clearable>
              <el-option
                  v-for="(item,index) in optionsMsku"
                  :key="index"

                  :label="item.storeName"
                  :value="item.storeName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 新添加字段： 数据来源接口 -->
          <el-form-item label="客服邮箱">
            <el-select v-model="addForm.storeMail" filterable clearable placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.supportEmail"
                  :value="item.supportEmail">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题类型">
            <el-select v-model="addForm.complaintType" placeholder="请选择" clearable>
              <el-option label="质量问题" value="1"></el-option>
              <el-option label="配件问题" value="2"></el-option>
              <el-option label="包装问题" value="3"></el-option>
              <el-option label="物流问题" value="4"></el-option>
              <el-option label="客户误操作" value="5"></el-option>
              <el-option label="客户取消订单" value="6"></el-option>
              <el-option label="客户无反馈" value="7"></el-option>
              <el-option label="亚马逊退货问题" value="8"></el-option>
              <el-option label="其他" value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="购买时间">
            <el-date-picker v-model="addForm.purchaseDate" clearable type="datetime"
                            placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="具体问题">
            <el-input v-model="addForm.detailedProblem" clearable></el-input>
          </el-form-item>
          <el-form-item label="跟踪进度">
            <el-input v-model="addForm.processingProgress" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="addForm.status" clearable placeholder="请选择">
              <el-option label="跟进中" value="1"></el-option>
              <el-option label="已解决" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDialogFalse">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑的对话框 -->
      <el-dialog title="客诉管理表" :visible.sync="editDialogVisible" width="30%" center @close="closeUpdate">
        <el-form :label-position="labelPosition" label-width="100px" :model="editForm">
          <el-form-item label="id" style="display:none">
            <el-input v-model="editForm.complaintId" clearable></el-input>
          </el-form-item>
          <el-form-item label="问题来源">
            <el-select v-model="editForm.sourceOfComplaint" clearable placeholder="请选择">
              <el-option label="账号邮件" value="1"></el-option>
              <el-option label="客服邮箱" value="2"></el-option>
              <el-option label="FB" value="3"></el-option>
              <el-option label="退款订单" value="4"></el-option>
              <el-option label="重发订单" value="5"></el-option>
              <el-option label="差评" value="6"></el-option>
              <el-option label="客户联系方式" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model="editForm.amazonOrderId" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="editForm.clientName" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model="editForm.contactInformation" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户FB-ID">
            <el-input v-model="editForm.buyerFb" clearable></el-input>
          </el-form-item>
          <el-form-item label="内部SKU">
            <el-input v-model="editForm.psku" @blur="handleEnterEdit" clearable></el-input>
          </el-form-item>
          <!-- 新增卖家sku字段，数据来源接口 -->
          <el-form-item label="卖家SKU">
            <el-select v-model="editForm.msku" filterable placeholder="请选择" clearable>
              <el-option
                  v-for="(item,index) in optionsMskuEdit"
                  :key="index"
                  :label="item.msku"
                  :value="item.msku">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售账号">
            <el-select v-model="editForm.sellerUser" filterable placeholder="请选择" clearable>
              <el-option
                  v-for="(item,index) in optionsMskuEdit"
                  :key="index"
                  :label="item.storeName"
                  :value="item.storeName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 新添加字段： 数据来源接口 -->
          <el-form-item label="客服邮箱">
            <el-select v-model="editForm.storeMail" filterable clearable placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.supportEmail"
                  :value="item.supportEmail">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题类型">
            <el-select v-model="editForm.complaintType" clearable placeholder="请选择">
              <el-option label="质量问题" value="1"></el-option>
              <el-option label="配件问题" value="2"></el-option>
              <el-option label="包装问题" value="3"></el-option>
              <el-option label="物流问题" value="4"></el-option>
              <el-option label="客户误操作" value="5"></el-option>
              <el-option label="客户取消订单" value="6"></el-option>
              <el-option label="客户无反馈" value="7"></el-option>
              <el-option label="亚马逊退货问题" value="8"></el-option>
              <el-option label="其他" value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="购买时间">
            <el-date-picker v-model="editForm.purchaseDate" clearable type="datetime"
                            placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="具体问题">
            <el-input v-model="editForm.detailedProblem" clearable></el-input>
          </el-form-item>
          <el-form-item label="跟踪进度">
            <el-input v-model="editForm.processingProgress" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" placeholder="请选择" clearable>
              <el-option label="跟进中" value="1"></el-option>
              <el-option label="已解决" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeUpdate">取 消</el-button>
          <el-button type="primary" @click="submitEdit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
//时间插件
import moment from "moment";
import {

  apiClientSearch,
  apiAddClientList,
  apiEditClientList,
  apiDeleteClientList,
  apiClientExport,
  apiImportFile,
  apiClientEmail,

} from "../../api/client";
import {apiSearchListingList} from "../../api/listing";

export default {
  data() {
    return {
      //顶部输入框
      searchBar: {
        sourceOfComplaint: '',
        complaintType: '',
        status: '',
        select: '',
        contactInformation: '',
        psku: '',
        detailedProblem: '',
        processingProgress: '',
        amazonOrderId: ''
      },
      AddDialogVisible: false,
      editDialogVisible: false,
      uploadLoading: false,
      downloadLoading: false,
      labelPosition: "right",
      //新增表单数据：
      addForm: {},
      //编辑表单数据：
      editForm: {},
      //分页器数据：
      currentPage: 1, //默认第一页 当前页
      size: 10,
      total: 0,//总条数
      //表格绑定数据
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      complaintTime: '',
      options: [],//客服邮箱初始数据
      optionsMsku: [],//卖家sku新增
      optionsMskuEdit: [],//卖家sku编辑
      fileList: [],//卖家sku编辑
    };
  },

  methods: {
    handleDelete(id) {
      // 提示用户是否删除
      this.$confirm('是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiDeleteClientList(id).then((res) => {
          if (res.data.code === 200) {
            this.search(false);
            this.$message.success(res.data.message)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 每页条数
    handleSizeChange(size) {
      this.size = size;
      this.search(false);
    },
    // 页码
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.search(false);
    },
    // 搜索
    search(boolean) {
      this.searchBar = this.common.clearNull(this.searchBar);
      this.currentPage = boolean ? 1 : this.currentPage;
      apiClientSearch({
        page: this.currentPage,
        size: this.size,
        q: JSON.stringify(this.searchBar),
        sort: "complaintId",
        direction: "DESC"
      }).then((res => {
        if (res.data.code === 200) {
          if (boolean) {
            this.$message.success(res.data.message)
          }
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
        } else {
          this.$message.error(res.data.message)
        }
      }))

    },
    // getClientList() {
    //   apiClientList({
    //     page: this.currentPage,
    //     size: this.size,
    //   }).then((res) => {
    //     if (res.data.code === 200) {
    //       // var rows = res.data.data.rows;
    //       // 遍历取值
    //       this.tableData = res.data.data.rows;
    //       this.total = res.data.data.total
    //     }
    //   });
    // },
    // 点击新增
    AddDialog() {
      this.AddDialogVisible = true;
      this.getEmail();//客服邮箱
    },

    //点击确定按钮新增数据
    submitAdd() {
      apiAddClientList(this.addForm).then((res) => {
        if (res.data.code === 200) {
          this.AddDialogVisible = false;
          this.addForm = {};
          this.search(false);
          this.$message.success(res.data.message)
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },
    // 点击关闭新增对话框
    AddDialogFalse() {
      this.AddDialogVisible = false;
      this.addForm = {};
    },
    //点击编辑回传数据
    //修改表单数据 双向修改改成深拷贝
    EditList(data) {
      this.editDialogVisible = true;
      this.editForm = JSON.parse(JSON.stringify(data));
      console.log(this.editForm);
      this.getEmail();//客服邮箱
    },
    //点击编辑按钮修改数据
    submitEdit() {
      apiEditClientList({
        id: this.editForm.complaintId,
        data: this.editForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.editDialogVisible = false;
          this.editForm = {};
          this.search(false);
          this.$message.warning(res.data.message);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },

    // 点击关闭新增对话框
    closeUpdate() {
      this.editDialogVisible = false;
      this.editForm = {};
    },
    // 导入
    handleBeforeUpload(file) {//上传文件之前的钩子，参数为上传的文件
      if (file.name.indexOf("xls") === -1 && file.name.indexOf("xlsx") === -1) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return false;
      }
    },
    // 成功
    husinessLicenseHandler(params) {//覆盖
      this.uploadLoading = true;
      const _file = params.file;
      var formData = new FormData()// 通过 FormData 对象上传文件
      formData.append('file', _file)
      apiImportFile(formData).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          this.search(true);
        } else {
          this.$message.error('导入失败');
        }
      }).finally(() => {
        this.fileList = [];
        this.uploadLoading = false;
      })
    },

    // 导出
    exportExcel() {
      this.downloadLoading = true;
      var filename = '客诉管理.xlsx';
      apiClientExport({q: JSON.stringify(this.searchBar)}).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
        let objectUrl = URL.createObjectURL(blob) // 创建URL
        link.href = objectUrl
        link.download = filename
        link.click()
        link.remove()
        URL.revokeObjectURL(objectUrl);
        // this.search(false);
      }).finally(() => {
        this.downloadLoading = false;
      })

    },
    // 获取客服邮箱
    getEmail() {
      apiClientEmail().then((res => {
        if (res.data.code == 200) {
          this.options = res.data.data;
        }
      }))
    },
    // 失去焦点新增
    handleEnter() {
      let i = {};
      i.psku = this.addForm.psku;
      i = this.common.clearNull(i);
      apiSearchListingList({size: 100, q: JSON.stringify(i), sort: "listingId"}).then((res => {
        if (res.data.code == 200) {
          this.optionsMsku = res.data.data.content;
          console.log(this.optionsMsku);
        } else {
          return false;
        }
      }))
    },
    // 失去焦点编辑
    handleEnterEdit() {
      let i = {};
      i.psku = this.editForm.psku;
      i = this.common.clearNull(i);
      apiSearchListingList({size: 100, q: JSON.stringify(i), sort: "listingId"}).then((res => {
        if (res.data.code == 200) {
          this.optionsMskuEdit = res.data.data.content;
        } else {
          return false;
        }
      }))
    },
    //  多条件搜索
    // getSearchDate() {
    //   apiClientSearch({
    //     page: this.currentPage,
    //     size: this.size,
    //     data: this.searchBar
    //   }).then((res => {
    //     if (res.data.code === 200) {
    //       this.tableData = res.data.data.rows;
    //       this.total = res.data.data.total;
    //     } else {
    //       this.$message.error(res.data.message)
    //     }
    //   }))
    // }
  },
  created() {
    //点进来就获取列表全部数据
    this.search(true);
  },
  //日期的格式化
  filters: {
    datefilter: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
      //这里的日期格式可自定义
    },
  },
};
</script>

<style lang="less" scoped>
.mainClient {
  .el-select .el-input {
    width: 150px;
  }
}

.el-input-group {
  // margin-left: 30px;
  width: 500px;
}

.client {
  padding: 50px 30px;

  .el-pagination {
    padding: 32px 0px;
  }
}

.el-select > .el-input {
  width: 80% !important;
}
</style>